import { render, staticRenderFns } from "./MarketRecommand.vue?vue&type=template&id=1c6442ac&scoped=true&"
import script from "./MarketRecommand.vue?vue&type=script&lang=js&"
export * from "./MarketRecommand.vue?vue&type=script&lang=js&"
import style0 from "./MarketRecommand.vue?vue&type=style&index=0&id=1c6442ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6442ac",
  null
  
)

export default component.exports